import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8 14A6 6 0 118 2a6 6 0 110 12m9.7 2.3l-3.39-3.4A7.96 7.96 0 0016 8a8 8 0 10-8 8 7.96 7.96 0 004.9-1.68l3.4 3.4a1 1 0 001.4-.01 1 1 0 000-1.41" fill="currentColor" /></svg>);